import { render, staticRenderFns } from "./GerarLinkDocumento.vue?vue&type=template&id=8c742728&scoped=true"
import script from "./GerarLinkDocumento.vue?vue&type=script&lang=js"
export * from "./GerarLinkDocumento.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8c742728",
  null
  
)

export default component.exports